import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { STORE_POLICY } from "../../common/constants";

export default function StorePolicy(props) {
  const { user } = useContext(UserContext);

  const storePolicy = user?.siteConfig?.policy || STORE_POLICY;

  return (
    <Box py={2}>
      <Typography
        dangerouslySetInnerHTML={{
          __html: storePolicy,
        }}
      ></Typography>
    </Box>
  );
}
